import React from 'react';
import Map, {Source, Layer} from 'react-map-gl';
import DeckGL from '@deck.gl/react';
import maplibregl from 'maplibre-gl';
import {broadcast, listen, stop_listen} from './utils'

const INITIAL_VIEW_STATE = {longitude: 30.340354, latitude: 59.931715, zoom: 14};

class MyMap extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      mode: 'cursor',
      user_id: false,
      cursor_move: false,
      view_state_external_user_id: false,
      view_state: {
        latitude: 59.931715,
        longitude: 30.340354,
        zoom: 14,
        bearing: 0,
        pitch: 0
      },
      tile_links: [],
      move_props: false,
      layers: [],
      listners: []
    }
  }

  componentDidMount(){
    const listners = [
      {type: "toolbar_mode_change", fnc: ({detail}) => this.setState({mode: detail.mode})},
      {type: "add_or_replace_layer", fnc: ({detail}) => {
        this.setState( (state) => ({layers:
          [
            ...state.layers.filter(v => v.id !== detail.id),
            detail
          ].sort((a, b) => (`${a.id}` > `${b.id}` ? 1 : `${b.id}` > `${a.id}` ? -1 : 0))
        }))
      }},
      {type: "update_user_view_state", fnc: ({detail}) => {
        if (detail.id === this.state.view_state_external_user_id) {
          this.setState({view_state: detail})
        }
      }},
      {type: "set_view_state", fnc: ({detail}) => {
        this.setState({view_state: detail, view_state_external_user_id: detail.id})
      }},
      {type: "set_map_coords", fnc: ({detail}) => {
        this.setState({
          view_state: {
            ...this.state.view_state,
            latitude: detail[1],
            longitude: detail[0],
            zoom: 16.4
          },
          view_state_external_user_id: this.props.user_id
        })
      }},
      {type: "user_avatar_click", fnc: ({detail}) => {
        if (detail.id === this.state.view_state_external_user_id) {
          this.setState({view_state_external_user_id: false})
        } else {
          if (detail.id && detail.view_state){
            this.setState({view_state_external_user_id: detail.id, view_state: detail.view_state})
          } else {
            this.setState({view_state_external_user_id: detail.id})
          }
        }
      }},
      {type: "map_tile_links", fnc: ({detail}) => this.setState({tile_links: detail})},
      {type: "current_user", fnc: ({detail}) => this.setState({user_id: detail.id})},
      {type: "remove_layer", fnc: ({detail}) => {
        this.setState((state) => ({layers: state.layers.filter(v => v.id !== detail && v.id !== `${detail}_1` && v.id !== `${detail}_notifications`)}))
      }},
    ]

    listners.forEach(l => listen(l.type, l.fnc))
    this.setState({listners})
  }

  componentWillUnmount(){
    this.state.listners.forEach(l => stop_listen(l.type, l.fnc))
  }

  render() {
    var layers = [...this.state.layers]
    var styles_json_url = "https://map.91.team/styles/starlight/style.json"

    this.state.tile_links.forEach(link =>
      styles_json_url = link.selected ? link.styles_json_url : styles_json_url
    )

    return (
      <div>
        <DeckGL
          layers={layers}
          onClick={e => {
            broadcast("map_click", {event: e, mode: this.state.mode, user_id: this.state.user_id})
          }}
          getCursor={e => {
            if (this.state.cursor_move) {
              return('move')
            } else {
              if (e.isHovering) {
                if (this.state.mode === 'cursor')
                  return('pointer')

                return('auto')
              } else {
                if (this.state.mode === 'cursor')
                  return('auto')
                if (this.state.mode === 'line')
                  return('none')
                if (this.state.mode === 'line_points')
                  return('auto')
                if (this.state.mode === 'polygon')
                  return('none')
                if (this.state.mode === 'polygon_points')
                  return('auto')
                if (this.state.mode === 'marker')
                  return('auto')
                if (this.state.mode === 'text')
                  return('crosshair')
                if (this.state.mode === 'lastik')
                  return('none')
                if (this.state.mode === '3d')
                  return('auto')
                if (this.state.mode === 'ark')
                  return('auto')
                if (this.state.mode === 'measures')
                  return('auto')
              }
            }
          }}
          initialViewState={INITIAL_VIEW_STATE}
          viewState={
            this.state.view_state_external_user_id ?
              this.state.view_state : false
          }
          onViewStateChange={e => {
            const view_state = {
              latitude: e.viewState.latitude,
              longitude: e.viewState.longitude,
              zoom: e.viewState.zoom,
              bearing: e.viewState.bearing,
              pitch: e.viewState.pitch,
            }

            broadcast("user_view_state", view_state)
            if (this.state.view_state_external_user_id){
              broadcast("user_view_state_stop_follow", {id: this.state.view_state_external_user_id})
              this.setState({view_state_external_user_id: false})
            }
          }}
          controller={{
            dragPan: this.state.mode !== 'polygon' && this.state.mode !== 'lastik' && this.state.mode !== 'line' && !this.state.cursor_move
          }}
          getTooltip={ obj => {
            if (obj.object && obj.object.properties && obj.object.properties.point_settings && obj.object.properties.point_settings.tooltip_text && typeof(obj.object.properties.id) == "number")
              return(obj.object.properties.point_settings.tooltip_text)

            if (obj.object && obj.object.properties && obj.object.properties.text_settings && obj.object.properties.text_settings.tooltip_text && typeof(obj.object.properties.id) == "number")
              return(obj.object.properties.text_settings.tooltip_text)

            if (obj.object && obj.object.properties && obj.object.properties.polygon_settings && obj.object.properties.polygon_settings.tooltip_text && typeof(obj.object.properties.id) == "number")
              return(obj.object.properties.polygon_settings.tooltip_text)

            if (obj.object && obj.object.properties && obj.object.properties.chat_settings && obj.object.properties.chat_settings.title && typeof(obj.object.properties.id) == "number"){
              return({
                style: {
                  "z-index": 1,
                  "position": "absolute",
                  "color": "#a0a7b4",
                  "background-color": "#29323c",
                  "padding": "10px",
                  "max-width": "300px"
                },
                text: obj.object.properties.chat_settings.title
              })
            }
          }}
          onDrag={e => {
            if (e.coordinate !== undefined && this.state.user_id)
              broadcast("user_map_drag", {
                id: this.state.user_id,
                coordinate: e.coordinate,
                mode: this.state.mode,
                move_props: this.state.move_props
              })
          }}
          onHover={e => {
            if (e.layer && e.layer.props && e.layer.props.data && e.layer.props.data && e.layer.props.data.properties.type === "video_edge"){
              if (!this.state.cursor_move)
                this.setState({cursor_move: true, move_props: e.layer.props.data.properties})
            } else {
              if (this.state.cursor_move)
                this.setState({cursor_move: false, move_props: false})
            }

            if (e.coordinate !== undefined && this.state.user_id)
              broadcast("user_map_hover", {id: this.state.user_id, coordinate: e.coordinate, mode: this.state.mode})
          }}
          onDragStart={e => {
            if (e.coordinate !== undefined && this.state.user_id)
              broadcast("user_map_drag_start", {
                id: this.state.user_id,
                coordinate: e.coordinate,
                mode: this.state.mode,
                move_props: this.state.move_props
              })
          }}
          onDragEnd={e => {
            if (e.coordinate !== undefined && this.state.user_id)
              broadcast("user_map_drag_end", {
                id: this.state.user_id,
                coordinate:
                e.coordinate,
                mode: this.state.mode,
                move_props: this.state.move_props
              })
          }}
        >
          <Map
            reuseMaps
            mapLib={maplibregl}
            mapStyle={styles_json_url}
            preventStyleDiffing={true}
          >
          {
            layers
            .filter(v => v.props && v.props.data && v.props.data.properties && v.props.data.properties.video_settings)
            .map(v => {
              return(
                [
                  <Source
                    key={`${v.id}_${v.props.data.properties.video_settings.url}_video_source`}
                    id={`${v.id}`}
                    type="video"
                    urls={[v.props.data.properties.video_settings.url]}
                    coordinates={[
                      v.props.data.properties.video_settings.coord1,
                      v.props.data.properties.video_settings.coord2,
                      v.props.data.properties.video_settings.coord3,
                      v.props.data.properties.video_settings.coord4
                    ]}
                  />,
                  <Layer
                    key={`${v.id}_${v.props.data.properties.video_settings.url}_video_layer`}
                    id={`${v.id}`}
                    type="raster"
                    source={`${v.id}`}
                  />
                ]
              )
            })
          }
          </Map>
        </DeckGL>
      </div>
    )
  }
}

// /galery_me1.MOV
export default MyMap;
